<template>
	<div class="ci-reply-list">
		<div class="ci-reply-list-item" v-for="(replay,key) in replayList">
			<div class="ci-reply-list-group" @click="rGroupClick(key)">
				<i :class="{'ci-reply-list-group-zk' : replay.spread}"></i>
				<p>{{replay.title}}</p>
			</div>
			<div class="ci-reply-list-info" v-for="replayOne in replay.children" v-if="replay.spread">
				<div class="ci-reply-list-l" @click="rClick(replayOne.id)" :title="replayOne.title">
					<i :class="replayOne.r_class"></i>
					<p>{{replayOne.title}}</p>
				</div>
				<div class="ci-reply-list-r" v-if="tab == 'personal'">
					<i @click="rDel(replayOne.id)"></i>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import AppConfig from '../../../../config/AppConfig.js'
	import {
		getQuicklyReplyList,
		delQuicklyReply
	} from '../../../network/web/quickly-reply.js'
	import {
		sendMsg
	} from '../../../socket/socketSender.js'
	import {webGetShortLink} from '../../../network/web/link.js'

	export default {
		name: 'ChatInfoReplyList',
		props: {
			kewords: {
				type: String,
				default: ''
			},
			type: {
				type: String,
				default: 'normal'
			},
			tab: {
				type: String,
				default: 'personal'
			}
		},
		data() {
			return {
				originList: [],
				replayList: []
			}
		},
		methods: {
			// 处理快捷列表-筛选数据
			handleReplyList() {
				let list = this.originList[this.tab]
				this.replayList = []
				if (list !== undefined && list.length > 0) {
					for (let i = 0; i < list.length; i++) {
						let children = []
						for (let j = 0; j < list[i].child.length; j++) {
							let r_id = 0
							let r_title = ''
							let r_class = ''
							if (this.type === 'normal') {
								// 判断搜索词
								if (this.kewords !== '' && list[i].child[j].title.indexOf(this.kewords) === -1) {
									continue
								}
								if (list[i].child[j].type == 2) {
									continue
								}
								r_id = list[i].child[j].id
								r_title = list[i].child[j].title
								if (list[i].child[j].type == 1) {
									r_class = 'ci-reply-list-icon-text'
								} else if (list[i].child[j].type == 3) {
									r_class = 'ci-reply-list-icon-img'
								} else if (list[i].child[j].type == 4) {
									r_class = 'ci-reply-list-icon-link'
								} else if (list[i].child[j].type == 5) {
									r_class = 'ci-reply-list-icon-audio'
								} else if (list[i].child[j].type == 30) {
									r_class = 'ci-reply-list-icon-finder'
								} else if (list[i].child[j].type == 31) {
									r_class = 'ci-reply-list-icon-finder'
								}
							} else if (this.type === 'program') {
								// 判断搜索词
								if (this.kewords !== '' && list[i].child[j].program_title.indexOf(this.kewords) === -1) {
									continue
								}
								if (list[i].child[j].type != 2) {
									continue
								}
								r_id = list[i].child[j].id
								r_title = list[i].child[j].program_title
								r_class = 'ci-reply-list-icon-program'
							}
							children.push({
								id: r_id,
								title: r_title,
								r_class: r_class
							})
						}
						let reply = {
							id: list[i].id,
							title: list[i].title,
							spread: false,
							children: children
						}
						if (children.length === 0) {
							continue
						}
						this.replayList.push(reply)
					}
				}
				// 第一个分组展开
				if (this.replayList.length > 0) {
					this.replayList[0].spread = true
				}
			},

			// 根据id，从原始数据中获取详细信息
			getInfo(id) {
				let list = this.originList[this.tab]
				let data = null
				if (list !== undefined && list.length > 0) {
					for (let i = 0; i < list.length; i++) {
						for (let j = 0; j < list[i].child.length; j++) {
							if (list[i].child[j].id == id) {
								data = list[i].child[j]
								break
							}
						}
						if (data !== null) {
							break
						}
					}
				}
				return data
			},

			// 刷新
			refresh() {
				let loading = CHAT_LAYER.open({
					type: 3
				})
				this.getRList(() => {
					CHAT_LAYER.close(loading)
				})
			},

			// 从获取获取快捷与列表
			getRList(callback) {
				let _this = this
				getQuicklyReplyList(data => {
					if (data.code == 1) {
						_this.originList = data.data
						this.handleReplyList()
						if (callback !== undefined) {
							callback()
						}
					}
				})
			},

			// 分组点击
			rGroupClick(i) {
				this.replayList[i].spread = !this.replayList[i].spread
			},

			// 快捷语点击
			rClick(id) {
				let reply = this.getInfo(id)
				if (reply === null) {
					CHAT_LAYER.msg('数据异常', {
						icon: 2
					})
					return
				}
				if (reply.type == 2) {
					sendMsg(this.$store.state.chatFans, reply.content, 'program', this)
				} else if (reply.type == 4) {
					let linkObj = JSON.parse(reply.reply)
					if(linkObj.link_img !== undefined && linkObj.link_img != ''){
						linkObj.link_img = linkObj.link_img+'?x-oss-process=style/thumb_90'
					}
					webGetShortLink(linkObj.link_url,data=>{
						if(data.code == 1){
							if(data.data.ShortUrl !== undefined){
								linkObj.link_url = data.data.ShortUrl
							}
						}
						sendMsg(this.$store.state.chatFans, JSON.stringify(linkObj), 'link', this)
					})	
				} else if (reply.type == 5) {
					sendMsg(this.$store.state.chatFans, reply.reply, 'voice', this)
				} else if (reply.type == 30) {
					sendMsg(this.$store.state.chatFans, reply.reply, 'finder', this)
				} else if (reply.type == 31) {
					sendMsg(this.$store.state.chatFans, reply.reply, 'finder_live', this)
				} else {
					let content = reply.reply
					if (reply.type == 3 && content.indexOf("http") === -1) {
						content = AppConfig.host + content
					}
					this.$emit('reply-click-call', {
						type: reply.type,
						content: content
					})
				}
			},

			// 快捷语删除
			rDel(id) {
				let _this = this
				CHAT_LAYER.confirm('确定要删除快捷语吗？',{
					btn:['确认','取消'],
				},function(index,layero){
					CHAT_LAYER.close(index)
					delQuicklyReply(id, res => {
						if (res) {
							_this.rLocalDel(id)
						} else {
							CHAT_LAYER.msg('操作失败', {
								icon: 2
							})
						}
					})
				},function(index,layero){
					// console.log('222')
				})
			},

			// 删除data里面的快捷语
			rLocalDel(id) {
				let list = this.originList[this.tab]
				if (list !== undefined && list.length > 0) {
					for (let i = 0; i < list.length; i++) {
						for (let j = 0; j < list[i].child.length; j++) {
							if (list[i].child[j].id == id) {
								list[i].child.splice(j, 1)
								break
							}
						}
					}
				}
				let list2 = this.replayList
				if (list2 !== undefined && list2.length > 0) {
					for (let i = 0; i < list2.length; i++) {
						for (let j = 0; j < list2[i].children.length; j++) {
							if (list2[i].children[j].id == id) {
								list2[i].children.splice(j, 1)
								break
							}
						}
					}
				}
				CHAT_LAYER.msg('操作成功', {
					icon: 1
				})
			}
		},
		mounted() {
			this.getRList()
		},

		watch: {
			// 监听搜索词的变化
			kewords(nVal) {
				this.handleReplyList()
			},

			type(nVal) {
				this.handleReplyList()
			},

			tab(nVal) {
				this.handleReplyList()
			}
		}
	}
</script>

<style>
	.ci-reply-list {
		font-size: 13px;
		color: #666666;
		user-select: none;
	}

	.ci-reply-list-group {
		padding: 6px 0;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		cursor: pointer;
	}

	.ci-reply-list-group i {
		width: 14px;
		height: 14px;
		display: block;
		background-image: url(../../../assets/img/right-arrow-bf.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 100% auto;
		margin-right: 10px;
	}

	.ci-reply-list-group .ci-reply-list-group-zk {
		background-image: url(../../../assets/img/down-arrow-bf.png);
	}

	.ci-reply-list-group p {
		width: 0;
		flex-grow: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.ci-reply-list-info {
		padding: 5px 0 5px 20px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		cursor: pointer;
	}

	.ci-reply-list-info .ci-reply-list-l {
		width: 0;
		flex-grow: 1;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.ci-reply-list-info .ci-reply-list-r {
		width: 22px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.ci-reply-list-info i {
		display: inline-block;
		width: 18px;
		height: 18px;
		background-position: center;
		background-repeat: no-repeat;
		background-size: 100% auto;
	}

	.ci-reply-list-l>i {
		margin-right: 6px;
	}

	.ci-reply-list-r>i {
		background-image: url(../../../assets/img/del-70-32.png);
		width: 16px;
		height: 16px;
	}

	.ci-reply-list-l p {
		width: 0;
		flex-grow: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100%;
	}

	.ci-reply-list-icon-text {
		background-image: url(../../../assets/img/text-icon-8a-32.png);
	}

	.ci-reply-list-icon-img {
		background-image: url(../../../assets/img/img-icon-8a-32.png);
	}

	.ci-reply-list-icon-program {
		background-image: url(../../../assets/img/program-icon-8a-32.png);
	}

	.ci-reply-list-icon-link {
		background-image: url(../../../assets/img/link-icon-8a-32.png);
	}

	.ci-reply-list-icon-audio {
		background-image: url(../../../assets/img/audio-icon-8a-48.png);
	}

	.ci-reply-list-icon-finder {
		background-image: url(/img/finder.png);
	}
</style>
